import * as L from 'leaflet';
import { Marker } from 'react-leaflet';
import type { ICoordinate } from '../../../../models/coordinate.model';

function RetailerMarker({ coordinates, name }: { coordinates: ICoordinate; name: string }) {
  const icon = L.divIcon({
    className: 'div-icon retailer-marker',
    iconSize: [26, 42],
    iconAnchor: [13, 42],
    html: `<div class="position-relative">
                         <img src="/icons/map-marker-vasttrafik-blue.svg" alt="${name}" class="w-100 h-100" />
                       </div>`,
  });

  return <Marker icon={icon} position={[coordinates.latitude, coordinates.longitude]} />;
}

export default RetailerMarker;
